const numberFormat = (value: number, options?: Intl.NumberFormatOptions): string => {
  if (Number.isNaN(value) || isNaN(value)) {
    return '-'
  }

  try {
    return new Intl.NumberFormat(undefined, options).format(value)
  } catch {
    // not every browser supports Intl.NumberFormat() so just return the string value
    return String(value)
  }
}

export default numberFormat
